var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgViseur = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 33,
  height: 33,
  viewBox: "0 0 33 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.5395 30.1752C10.2819 25.2984 4.58265 14.9031 1.71044 9.71792C0.741566 7.96882 1.25766 5.78087 2.98486 4.77346C6.3539 2.80841 11.9365 0 16.325 0C20.7681 0 26.4353 2.87877 29.7899 4.84645C31.461 5.82661 31.9996 7.9286 31.1257 9.65761C28.6928 14.471 23.8939 23.9814 20.8203 30.1752C19.1965 33.4474 14.0797 33.5023 12.5395 30.1752Z",
  fill: "url(#paint0_linear_23734_287709)",
  fillOpacity: 0.8
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_23734_287709",
  x1: 16.325,
  y1: 0,
  x2: 16.325,
  y2: 32.65,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "currentColor",
  stopOpacity: 0.15
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.634615,
  stopColor: "currentColor"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgViseur);
export { ForwardRef as ReactComponent };